import {Action} from "redux";
import {isType} from "typescript-fsa";
import {session} from "@neolab/ice-client";

import {Permissions} from "@slices/Permissions/Permissions";
import {loadUser} from "src/sagas/iceClient.actions";


export type UserState = Permissions.Principal | null;

export default (state: UserState = null, action: Action): UserState => {
  if (isType(action, loadUser.done))
    return action.payload.result;

  if (isType(action, session.done))
    return null;

  return state;
};



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/user.ts